import { getPostHogClient } from './posthog';
import {
  planKeyFromTranslationKey,
  sanitizeCaptureProperties,
} from './urlSanitizer';

export const EVENTS = Object.freeze({
  BILLING_PERIOD_CHANGE: 'pricing:billing_period_change',
  PLAN_CTA_CLICK: 'pricing:plan_cta_click',
  FORM_OPEN: 'lead:form_open',
  FORM_VALIDATION_FAIL: 'lead:form_validation_fail',
  SUBMISSION_SUCCEED: 'lead:submission_succeed',
  SUBMISSION_FAIL: 'lead:submission_fail',
  WHATSAPP_CTA_CLICK: 'contact:whatsapp_cta_click',
});

export const trackEvent = (eventName, properties = {}) => {
  const client = getPostHogClient();

  if (!client || !Object.values(EVENTS).includes(eventName)) {
    return;
  }

  try {
    client.capture(eventName, sanitizeCaptureProperties(eventName, properties));
  } catch (error) {
    // Analytics is intentionally best effort.
  }
};

export { planKeyFromTranslationKey };
